module.exports = __webpack_public_path__ + "img/aboutbaner.269f8ed0.png";